import { render } from "./PpcStrategiesModalAllocation.vue?vue&type=template&id=19dbcdc9&scoped=true"
import script from "./PpcStrategiesModalAllocation.vue?vue&type=script&lang=js"
export * from "./PpcStrategiesModalAllocation.vue?vue&type=script&lang=js"

import "./PpcStrategiesModalAllocation.vue?vue&type=style&index=0&id=19dbcdc9&lang=scss"
import "./PpcStrategiesModalAllocation.vue?vue&type=style&index=1&id=19dbcdc9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19dbcdc9"]])

export default __exports__